import { getInitialState, updateState } from "@/utils/helpers/StoreUtil";
import DataProvider from "@/utils/helpers/DataProvider";

import { AxiosError, AxiosResponse } from "axios";
import { ActionTree, MutationTree, Module } from "vuex";

import { State as RootState } from "@/store";

import { ITeacher, ITeacherPayload } from "@/models/interfaces/teachers";
import { IVuexState } from "@/models/interfaces/store";

export interface State {
  teachers: IVuexState<ITeacher[]>;
  teacher: IVuexState<ITeacher>;
}

export const actions: ActionTree<State, RootState> = {
  async fetchTeachers({ commit }) {
    commit("setTeachers");

    return DataProvider.get("teachers")
      .then((response: AxiosResponse) => {
        commit("setTeachers", response.data);
        return response.data;
      })
      .catch((error: AxiosError) => {
        commit("setTeachers", error);
        return error;
      });
  },

  async deleteTeachers({ commit, state }, teachersIds: string[]) {
    const { teachers } = state;

    try {
      const deleteRequests = teachersIds.map(id =>
        DataProvider.delete(`teachers/${id}`)
      );
      const filteredTeachers = teachers.data!.filter(
        ({ userId }) => !teachersIds.includes(userId)
      );

      const result = await Promise.all(deleteRequests);
      commit("setTeachers", filteredTeachers);

      return result;
    } catch (error) {
      return error;
    }
  },

  async fetchTeacherById({ commit }, teacherId: string) {
    commit("setTeacher");

    return DataProvider.get(`teachers/${teacherId}`)
      .then((response: AxiosResponse) => {
        commit("setTeacher", response.data);
        return response.data;
      })
      .catch((error: AxiosError) => {
        commit("setTeacher", error);
        return error;
      });
  },

  createTeacher(store, payload: ITeacherPayload) {
    return DataProvider.post("teachers", payload);
  },

  editTeacher(store, data: { payload: ITeacherPayload; teacherId: string }) {
    return DataProvider.patch(`teachers/${data.teacherId}`, data.payload);
  }
};

export const mutations: MutationTree<State> = {
  setTeachers(state, data?: ITeacher[] | AxiosError) {
    state.teachers = updateState(state.teachers, data);
  },

  setTeacher(state, data?: ITeacher | AxiosError) {
    state.teacher = updateState(state.teacher, data);
  }
};

const store: Module<State, RootState> = {
  namespaced: true,
  state: {
    teachers: getInitialState(),
    teacher: getInitialState()
  },
  mutations,
  actions
};

export default store;
